import immutableStore from 'alt-utils/lib/ImmutableUtil';
import pickBy from 'lodash/pickBy';
import keys from 'lodash/keys';
import alt from 'components/Dispatcher';
import AdminWelcomeEmailSource from 'sources/admin/AdminWelcomeEmailSource';
import ConstValues from 'utils/const';
import {Map, Record, List} from 'immutable';
import AdminWelcomeEmailActions from 'actions/admin/AdminWelcomeEmailActions';

const {adminWelcomeEmailTypes: TYPES} = ConstValues;

const State = Record({
  selected: Map({
    [TYPES.invite]: Map({}),
    [TYPES.reminder]: Map({}),
  }),
  lists: Map({
    [TYPES.invite]: List(),
    [TYPES.reminder]: List(),
  }),
  sending: Map({
    [TYPES.invite]: false,
    [TYPES.reminder]: false,
  }),
  sent: Map({
    [TYPES.invite]: false,
    [TYPES.reminder]: false,
  }),
  error: Map({
    [TYPES.invite]: null,
    [TYPES.reminder]: null,
  }),
  loading: true,
});

/**
 * Stores the state of Admin User forms
 */
@immutableStore
class AdminWelcomeEmailStore {
  constructor() {
    this.state = State();
    this.bindActions(AdminWelcomeEmailActions);
    this.registerAsync(AdminWelcomeEmailSource);
  }

  onFetchUserList(args) {
    this.setState(State());
    this.getInstance().fetchUserList();
  }

  onFetchUserListSuccess(userList) {
    userList = userList.sortBy(u => u.displayName);
    const invitesList = userList.filter(u => !u.remindersSent && !u.hasLoggedIn);
    const remindersList = userList.filter(u => u.remindersSent > 0);
    this.setState(
      this.state
        .set('loading', false)
        .set(
          'lists',
          Map({
            [TYPES.invite]: List(invitesList),
            [TYPES.reminder]: List(remindersList),
          })
        )
        .set(
          'selected',
          Map({
            [TYPES.invite]: this.initCheckMap(invitesList),
            [TYPES.reminder]: this.initCheckMap(remindersList),
          })
        )
    );
  }

  fetchUserListError(error) {
    console.error(error);
  }

  /**
   * Converts a list to a map of {[x.id]: false}, used for initializing each selected items Map()
   * @param arr
   */
  initCheckMap(arr) {
    return Map(
      arr.reduce((m, v) => {
        m[v.id] = false;
        return m;
      }, {})
    );
  }

  onSelectItem(args) {
    const [key, id] = args;
    this.setState(
      this.state
        .setIn(['selected', key, id], !this.state.getIn(['selected', key, id]))
        .setIn(['sent', key], false)
    );
  }

  onSelectAllItems(key) {
    const allSelected = !this.state.getIn(['selected', key]).findEntry(v => !v);
    this.setState(
      this.state
        .setIn(
          ['selected', key],
          this.state.getIn(['selected', key]).map(v => !allSelected)
        )
        .setIn(['sent', key], false)
    );
  }

  onSendWelcome(key) {
    this.key = key; // keep around whether its 'invites' or 'reminders'; we'll use it in AJAX callbacks below

    // Get user_ids from invitesList, which is a {[id]: bool} object
    const all = this.state.getIn(['selected', key]);
    const selected = keys(pickBy(all.toJS(), v => v));
    if (!selected.length) {
      return;
    }
    setImmediate(() => this.getInstance().sendWelcome(selected));
  }

  onSendWelcomeSuccess(resp) {
    this.setState(
      this.state
        .setIn(['sent', this.key], true)
        .setIn(['sending', this.key], false)
        .setIn(['error', this.key], false)
    );
    // Then reset our list & checkboxes
    setImmediate(() => this.getInstance().fetchUserList());
  }

  onSendWelcomeLoading(resp) {
    this.setState(
      this.state
        .setIn(['sent', this.key], false)
        .setIn(['sending', this.key], true)
        .setIn(['error', this.key], false)
    );
  }

  onSendWelcomeError(resp) {
    this.setState(
      this.state
        .setIn(['sent', this.key], false)
        .setIn(['sending', this.key], false)
        .setIn(['error', this.key], true)
    );
  }
}

export default alt.createStore(AdminWelcomeEmailStore, 'AdminWelcomeEmailStore');
